// extracted by mini-css-extract-plugin
export default {"control":"Control_control__mMDka","button":"Control_button__sf-by"};